export const getIOSVersion = () => {
    const ua = navigator.userAgent || "";
    // Matches: "OS 16_6" or "OS 16_6_1" in iPhone/iPad UAs
    const match = ua.match(/OS (\d+)[._](\d+)(?:[._](\d+))?/);
  
    if (!match) return null;
  
    const major = match[1];
    const minor = match[2];
    const patch = match[3] ?? "0";
  
    return `${major}.${minor}.${patch}`;
  };
  